import { render, staticRenderFns } from "./standardCommonFolder.vue?vue&type=template&id=25fdd595&scoped=true"
import script from "./standardCommonFolder.vue?vue&type=script&lang=js"
export * from "./standardCommonFolder.vue?vue&type=script&lang=js"
import style0 from "./standardCommonFolder.vue?vue&type=style&index=0&id=25fdd595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fdd595",
  null
  
)

export default component.exports